module.exports = __webpack_public_path__ + "static/media/java.5527be31.png";